import { Avatar, Card, Icon, Space, Typography } from '@sravni/react-design-system';
import { Bank } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import React from 'react';

import styles from './OfferDetailsCard.module.scss';

interface OfferPreviewCardProps {
  title: string;
  subtitle: string;
  logo: string;
  details: Array<{ label: string; value: string }>;
  containerProps?: React.ComponentProps<typeof Space>;
  detailsProps?: React.ComponentProps<typeof Space>;
}

export const OfferDetailsCard = ({
  title,
  subtitle,
  logo,
  details,
  containerProps = {},
  detailsProps = {},
}: OfferPreviewCardProps) => {
  const isMobile = useIsMobile();
  return (
    <Space direction="vertical">
      <Card size={isMobile ? 16 : 24}>
        <Space
          direction="vertical"
          size={16}
        >
          <Space
            size={16}
            direction="vertical"
            {...containerProps}
          >
            <Space
              size={16}
              align="center"
            >
              {logo ? (
                <Avatar
                  className={styles.avatar}
                  size={36}
                  src={logo}
                />
              ) : (
                <Icon
                  size={28}
                  icon={<Bank />}
                />
              )}

              <Space
                size={2}
                direction="vertical"
              >
                <Typography.Heading level={4}>{title}</Typography.Heading>

                <Typography.Text size={14}>{subtitle}</Typography.Text>
              </Space>
            </Space>

            <Space
              className={styles.summaries}
              size={isMobile ? 8 : 16}
              {...detailsProps}
            >
              {details.map((detail) => {
                return (
                  <Space
                    className={styles.summary}
                    size={2}
                    direction="vertical"
                    key={detail.label}
                  >
                    <Typography.Text
                      className={cn(styles.detailText, 'h-color-D60')}
                      size={12}
                    >
                      {detail.label}
                    </Typography.Text>

                    <Typography.Text
                      className={styles.detailText}
                      strong
                      size={16}
                    >
                      {detail.value}
                    </Typography.Text>
                  </Space>
                );
              })}
            </Space>
          </Space>
        </Space>
      </Card>
    </Space>
  );
};
